import { triggerSnowplowImpressionEvent } from '@themuse/snowplow-js-client';

import useUser from '../../useUser';

const MEDIA_TYPE_VIDEO = 'video';

export const SnowplowImpressionTracker = ({
    component,
    tileType = null,
    modalType = null,
    modalScreenOrder = null,
    modalScreenName = null,
    buttonType = null,
    insertType = null,
    cardType = null,
    position = 'main',
    searchId = null,
    companyId = null,
    pageSection = null,
    pageTab = null,
    pageType = null,
    pagePosition = null,
    tileEntityId = null,
    tileEntityUuid = null,
    pageEntityId = null,
    pageEntityUuid = null,
    tileOrder = 0,
    tileLocation = null,
    mediaType = null,
    companyName = null,
    providerKey = null,
    providerName = null,
    mediaId = null,
    isExternal = null,
}) => {
    const { user, userLoading } = useUser();
    const baseJson = {
        sp_impression_component: component,
        sp_impression_tile_type: tileType,
        sp_impression_insert_type: insertType,
        sp_impression_modal_type: modalType,
        sp_impression_position: position,
        sp_impression_search_id: searchId,
        sp_impression_button_type: buttonType,
        sp_impression_card_type: cardType,
        ...(mediaType === MEDIA_TYPE_VIDEO
            ? {
                sp_media_type: mediaType,
                sp_media_name: `${companyName} - Job Video`,
                sp_media_id: mediaId,
                sp_media_provider_key: providerKey,
                sp_media_provider_name: providerName,
            }
            : {
                sp_modal_screen_order: modalScreenOrder,
                sp_modal_type: modalType,
                sp_modal_screen_name: modalScreenName,
                sp_tile_type: tileType,
                sp_tile_entity_id: tileEntityId,
                sp_tile_entity_uuid: tileEntityUuid,
                sp_tile_order: tileOrder,
                sp_tile_location: tileLocation,
                sp_tile_company_id: companyId ? String(companyId) : null,
            }),
    };

    const element = document.createElement('div');
    element.setAttribute('data-tracking-props', JSON.stringify(baseJson));

    if (!userLoading) {
        if (mediaType === MEDIA_TYPE_VIDEO) {
            const index = window.dataLayer.findIndex(
                (obj) => 'sp_page_section' in obj
            );
            const pageData = {
                sp_page_is_external: isExternal,
                sp_page_type: pageType,
                sp_page_section: pageSection,
                sp_page_tab: pageTab,
                sp_user_id: user.id,
                sp_user_logged_in: !!user.id,
                sp_page_page_company_id: companyId ? String(companyId) : null,
                sp_page_position: pagePosition,
                sp_page_entity_id: pageEntityId,
                sp_page_uuid: pageEntityUuid,
            };
            if (index >= 0) {
                window.dataLayer[index] = pageData;
            } else {
                window.dataLayer.push(pageData);
            }
        }
        triggerSnowplowImpressionEvent(element);
    }

    return null;
};

export const convertMetricToSnowPlowImpressionTracker = (snowPlow) => {
    SnowplowImpressionTracker({
        ...snowPlow,
    });
};
